module.exports = __webpack_public_path__ + "img/aegina.be401874.jpg";